
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Image from 'react-bootstrap/Image';
// import im_WhoWeAre from "../static/images/im_WhoWeAre.jpg"

import "../style/App.css";
import "../style/ReactBootstrapOverride.css";
import "../style/Home.css";


const WhatWeDo = () => {

    return (
        <Container fluid className="gradient-wwd h-25">
            <Row  className="px-5 mx-5 py-3 my-3">
                <Row className="col-white">
                    <h1>
                        WHAT WE DO
                    </h1>
                </Row>
                <Row>
                    {/* <Col> */}
                        <p className="col-white">
                        We are on a mission to transform surgical training for the next generation of surgeons. Our innovative suite of tools ensures a high standard of training while optimising time commitments for attending surgeons and program directors.
                        </p>
                        <p className="col-white">
                        The concept of repeated, quantitative, face-to-face feedback with experts is underscored by our belief that established training programs are inefficient for both trainee and surgeon and not based on either the established theories or contemporary thoughts on expert skill acquisition.
                        </p>
                        {/* <p className="col-white">
                        We believe in the importance of extensive observation, domain-general and domain-specific practice with quantitative feedback and acknowledge an evolving standard which emphasises a proficiency based progression through contemporary surgical training.
                        </p>
                        <p className="col-white">
                        Residents benefit from repeated simulation attempts in a safe and consistent environment, ensuring their readiness for the operating table. Advanced technologies and automation tools provide standardised quantitative performance data, enabling easy access and transfer of progress between institutions.
                        </p>
                        <p className="col-white">
                        Our mission is to relieve the administrative and operational burden on senior surgeons, allowing them to focus on passing on their knowledge and expertise. With CFI Surgery, surgical training becomes fast, efficient, and effective. Join us in reshaping the future of surgical education.
                        </p> */}
                    {/* </Col> */}
                    {/* <Col>
                        <Row className='home-image'>
                            <Col>
                        <Image src={im_WhoWeAre} alt="im_WhoWeAre" fluid rounded></Image>
                            </Col>
                            <Col>
                        <Image src={im_WhoWeAre} alt="im_WhoWeAre" fluid rounded></Image>
                            </Col>
                        </Row>
                        
                        <Row className='home-image'>
                            <Col>
                        <Image src={im_WhoWeAre} alt="im_WhoWeAre" fluid rounded></Image>
                            </Col>
                            <Col>
                        <Image src={im_WhoWeAre} alt="im_WhoWeAre" fluid rounded></Image>
                            </Col>
                        </Row>
                        
                    </Col> */}
                </Row>
            </Row>
        </Container>
    );
}

export default WhatWeDo;